import { ICaseStudyItem } from './case-study-list-item/case-study-article-list-item';

export const getAllCategories = (caseStudy: ICaseStudyItem): string[] => {
  if (!caseStudy) {
    return;
  }

  const industry = caseStudy.categoryIndustry
    ? caseStudy.categoryIndustry.map(categrory => categrory.categoryUrl)
    : [];
  const country = caseStudy.categoryCountry
    ? caseStudy.categoryCountry.map(categrory => categrory.categoryUrl)
    : [];
  const project = caseStudy.categoryProject
    ? caseStudy.categoryProject.map(categrory => categrory.categoryUrl)
    : [];
  const technology = caseStudy.categoryTechnology
    ? caseStudy.categoryTechnology.map(categrory => categrory.categoryUrl)
    : [];

  return [...industry, ...country, ...project, ...technology];
};
